let wow = new WOW();

wow.init({
    mobile: false,
    offset: (window.innerHeight/3)+'px',
    live: false,
});
